import React from 'react';
import HorizontalMenu from '../components/common/horizontalMenu';

const SendEstimatePage: React.FC = () => {
  return (
    <>
      <HorizontalMenu />
      <div className="container mx-auto max-w-7xl px-4 py-6">
        <h2 className="text-2xl font-semibold mb-6">Send Estimate</h2>
        
        <p className="text-base text-gray-600">
          Need to search customer and project first, and list all the estimates to let user select and send it out: TBD
        </p>
      </div>
    </>
  );
};

export default SendEstimatePage;